import { forwardRef, type Ref, type SVGProps } from "react";
const IconGridFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <rect width={12} height={12} x={2} y={2} rx={1} />
    <rect width={12} height={12} x={18} y={2} rx={1} />
    <rect width={12} height={12} x={2} y={18} rx={1} />
    <rect width={12} height={12} x={18} y={18} rx={1} />
  </svg>
);
const ForwardRef = forwardRef(IconGridFilledSVG);
ForwardRef.displayName = "IconGridFilled";
export { ForwardRef as IconGridFilled };
